import { NavLink, useNavigate } from "react-router-dom";
import "./styles.scss";
import MyButton from "../myButton";
import { scrollToForm } from "../../utils/scrolls";
import { Constants } from "../../utils/constants";
import Logo from "../logo";

export default function Footer() {
	const navigate = useNavigate();

	const scrollToTop = () => {
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	};

	return (
		<footer className="footer">
			<div className="footer-content">
				<div className="footer-main">
					<div className="footer-brand">
						<Logo onClick={scrollToTop} />
						<p className="footer-description">خدمة فردية مستقلة لمساعدة العملاء في إعداد وتنظيم معلومات الشكاوى بوضوح.</p>
					</div>

					<div className="footer-contact">
						<span className="footer-label">التواصل</span>
						<a href={`mailto:${Constants.contactEmail}`}>{Constants.contactEmail}</a>
						<span>{Constants.operatorAddress}</span>
					</div>

					<div className="footer-actions">
						<MyButton onClick={() => scrollToForm(navigate, "#form-card")}>طلب مساعدة</MyButton>
					</div>
				</div>

				<div className="footer-bottom">
					<p className="footer-compliance-text">خدمة مستقلة وليست بوابة حكومية أو مكتب محاماة أو جهة مرخصة لتقديم الاستشارات القانونية أو تشغيل منصة شكاوى إلكترونية. لا نطلب كلمات مرور أو بيانات دفع ولا نجمع مدفوعات عبر الموقع.</p>
					<div className="footer-meta">
						<div className="footer-links">
							<NavLink className="footer-navlink" to="/" onClick={scrollToTop}>
								الرئيسية
							</NavLink>
						<NavLink className="footer-navlink" to="/about" onClick={scrollToTop}>
							عن الخدمة
						</NavLink>
						<NavLink className="footer-navlink" to="/privacy-policy" onClick={scrollToTop}>
							سياسة الخصوصية
						</NavLink>
						<NavLink className="footer-navlink" to="/terms-of-use" onClick={scrollToTop}>
							شروط الاستخدام
						</NavLink>
					</div>
						<p className="footer-copyright">© {new Date().getFullYear()} {Constants.companyName}</p>
					</div>
				</div>
			</div>
		</footer>
	);
}
